module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("04nA7"))).then(() => parcelRequire('5erN3'));